import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { DataTable, DataTableRowClickEvent } from "primereact/datatable";
import { Column } from "primereact/column";
import { usePlacementEnvironments } from "../../api/queries/placement-environment/usePlacementEnvironments";
import { PlacementEnvironmentListItem } from "../../api/types/placement-environment";
import {
  formatDateTime,
  parseQueryString,
  toQueryString,
} from "../../common/utils";
import { userContext } from "../../context/user";

export default function PlacementEnvironmentList() {
  const navigate = useNavigate();
  const queryParams = parseQueryString(useLocation().search);
  const limit = 20;
  const [offset, setOffset] = useState(0);
  const [total, setTotal] = useState(0);
  const [sortField, setSortField] = useState(queryParams.sortField);
  const [sortOrder, setSortOrder] = useState(queryParams.sortOrder);
  const onPage = (event: any) => setOffset(event.first);
  const onSort = (event: any) => {
    setSortField(event.sortField);
    setSortOrder(event.sortOrder);
  };
  const { isAdmin } = useContext(userContext);

  const { data: placementEnvironments, isLoading } = usePlacementEnvironments({
    limit,
    offset,
  });

  const tName = (row: PlacementEnvironmentListItem) => row.name || "";

  const tDescription = (row: PlacementEnvironmentListItem) =>
    row.description || "";

  const tInstitutions = (row: PlacementEnvironmentListItem) =>
    row.institutions.map((institution) => institution.name).join(", ");

  const tContext = (row: PlacementEnvironmentListItem) => row.journey_type.name;

  const tCreatedAt = (row: PlacementEnvironmentListItem) =>
    formatDateTime(row.created_at);

  const onRowClick = (event: DataTableRowClickEvent) =>
    navigate(`/journey-trackers/${event.data.id}`);

  useEffect(() => {
    const queryParamsStr = toQueryString({
      limit,
      offset,
      sortField,
      sortOrder,
    });
    navigate({ search: queryParamsStr });
  }, [offset, navigate, sortField, sortOrder]);

  useEffect(() => {
    if (placementEnvironments) {
      setTotal(placementEnvironments.data.total_count);
    }
  }, [placementEnvironments, isAdmin, navigate]);

  return (
    <div className={"col-12"}>
      <div className="flex py-3">
        <h1 className="m-0">Journey Tracker</h1>

        {/* <Button
          onClick={() => navigate("/journey-trackers/new")}
          className="p-button p-button-main p-button-sm ml-auto"
          label="Add new"
        /> */}
      </div>

      <DataTable
        emptyMessage={"No records"}
        paginator={true}
        lazy={true}
        rows={limit}
        first={offset}
        totalRecords={total}
        loading={isLoading}
        sortField={sortField}
        sortOrder={sortOrder}
        onPage={onPage}
        onSort={onSort}
        className="p-datatable-sm p-datatable-pointer"
        onRowClick={onRowClick}
        stripedRows={true}
        value={placementEnvironments?.data.results || []}
      >
        <Column header={"Name"} body={tName} />

        <Column header={"Description"} body={tDescription} />

        <Column header={"Institutions"} body={tInstitutions} />

        <Column header={"Context"} body={tContext} />

        <Column header={"Created at"} body={tCreatedAt} />
      </DataTable>
    </div>
  );
}
